import  { useEffect, useRef, useState } from 'react'
import {  Slider, SliderChangeEvent, SliderHandle } from '@progress/kendo-react-inputs'
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_GetValueResponse } from '../../../api'
import { Label } from "@progress/kendo-react-labels";
import parse from 'html-react-parser'

interface SliderProps {
  id: number,
  question: string,
  minValue: number,
  maxValue: number,
  defaultValue: number,
  stepValue: number,
  isError: boolean,
  focus:boolean,
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const SliderCommand = (props: SliderProps) => {
  const [value, setValue] = useState(props.defaultValue);
  const labelId = `${props.id}_label`;
  const sliderRef = useRef<SliderHandle>();

  useEffect(() => {

    if(props.focus) {
      (sliderRef.current?.sliderTrack?.querySelector('.k-draghandle') as HTMLElement).focus();
    }

    let response: SurveyEngine_Models_GetValueResponse = {
      commandType: "SLIDER",
      commandIndex: props.id,
      value: String(value)
    }
    props.callback(response);
  }, [props,value]);

  const handleSliderChange = (e: SliderChangeEvent) => {
    
    let response: SurveyEngine_Models_GetValueResponse = {
      commandType: "Remove",
      commandIndex: props.id,
      value: "-1"
    };
    let newValue: number = Math.trunc(e.value / props.stepValue) * props.stepValue

    //if current value + step exceeds the max, will not increment the value, set it to the max
    if(value + props.stepValue > props.maxValue && value < props.maxValue){
      newValue = props.maxValue;
    }
    
    response = {
      commandType: "SLIDER",
      commandIndex: props.id,
      value: String(newValue)
    }
    props.callback(response);
    setValue(newValue);
  }

  return (
    <div className="theme-slider">
      <Label className="theme-question py-10 text-xl font-semibold" id={labelId}>
        {parse(props.question.replace(/""/g,'"'))}
      </Label>
      <div className="theme-answer py-4 flex w-full">
        <div className="basis-11/12 pt-1 align-middle">
          <Slider 
            ref={sliderRef}
            tabIndex={0} 
            ariaLabelledBy={labelId}
            step={props.stepValue}
            defaultValue={value}
            min={props.minValue}
            max={props.maxValue}
            className="!w-full theme-slider-color"
            value={value}
            onChange={(e) => handleSliderChange(e)}
          >
            {/* <SliderLabel position={props.minValue}></SliderLabel>
            <SliderLabel position={props.maxValue}></SliderLabel> */}
          </Slider>
        </div>
        <div className="basis-1/12 text-right px-2 align-middle text-xl font-semibold">
          {value}
        </div>
      </div>
    </div>
  )
}

